const routes = {
  videoAssessment: '/video-assessment/:id',
  applications: '/assessments/:id',
};

export default routes;
